/**
 * NOTE: customDimension is limited to 20,
 * if you need more check https://documentation.npaw.com/integration-docs/docs/options-video-js#second-option-example
 * */
export const PLAYER_TYPE_KEY = 'content.customDimension.1';
export const CONTENT_TAG_KEY = 'content.customDimension.2';
export const ENTRY_TYPE_KEY = 'content.customDimension.3';
export const TEACHER_FULL_NAME_KEY = 'content.customDimension.4';
export const COURSE_ID_KEY = 'content.customDimension.5';
export const COURSE_MODULE_ID_KEY = 'content.customDimension.6';
export const COURSE_TITLE_KEY = 'content.customDimension.7';
export const COURSE_MODULE_TYPE_KEY = 'content.customDimension.8';
export const COURSE_ACCESS_TYPE_KEY = 'content.customDimension.9';
export const SERIES_TITLE_KEY = 'content.customDimension.10';
